<script setup>
import { __, getFormValuesFromLocalStorage, checkIfOnlyEsim, getZipCode, setFormValues } from '@/utils';
import { useField, ErrorMessage } from 'vee-validate';
import { ref, watch, inject } from 'vue';
import debounce from 'lodash/debounce';

import FieldCity from '@components/fieldCity/fieldCity.vue';
import FieldStreet from '@components/fieldStreet/fieldStreet.vue';
import FieldsAddress from '@components/fieldsAddress/fieldsAddress.vue';
import { useDisableCityField } from '@composables/useDisableCityField';

const props = defineProps(['name', 'label','title']);

const savedFields = getFormValuesFromLocalStorage();
const clientType = props.name;
const showShippingAddress = ref(savedFields[`${clientType}SendSimToAddress`]);
const { handleChange: handeityCode } = useField(`${clientType}ShippingCityCode`);
const { handleChange: handleStreetCode } = useField(`${clientType}ShippingStreetCode`);
const { handleChange: handleSendSimToAddress} = useField(`${clientType}SendSimToAddress`);
const { handleChange: handleZipCode} = useField('shippingzipCode');
const { handleChange: handleZipStatus } = useField(`${clientType}ZipStatus`)

const shippingSettlementName = clientType === 'subscriber' ? 'subscriberShippingSettlement' : 'companyShippingSettlement';
const shippingStreettName = clientType === 'subscriber' ? 'subscriberShippingStreet' : 'companyShippingStreet';
const onlyEsim = ref(checkIfOnlyEsim());
 
const cityCode = ref(savedFields[`${clientType}ShippingCityCode`] ? savedFields[`${clientType}ShippingCityCode`] : '');

const { isExistingAccount, showLoader } = inject('step2');
const showShipping = ref(isExistingAccount.value);

const sendSimToAddress = () => {
	showShippingAddress.value = !showShippingAddress.value;

	handleSendSimToAddress(showShippingAddress.value)
}

const fetchZipCode = debounce(async() => {
	showLoader.value = true;
    const response = await getZipCode(clientType, true);
    if ( response ) {
        const apiResponse = JSON.parse(response.data);
        const zipCode = apiResponse.response[0]?.name;

		handleZipStatus(apiResponse.response['error']);

        if (zipCode) {
            handleZipCode(zipCode);
            let zipCodeType =  `${clientType}ShippingzipCode`;
            setFormValues({
                [zipCodeType]: zipCode
            })
        }else{
            handleZipCode('');
        }
    }else{
        handleZipCode('');
    }
	showLoader.value = false;
}, 300);

const handleSelectedCity = ({code, name}) => {
    handeityCode(code);
    cityCode.value = code;
	fetchZipCode();
}

const handleSelectedStreet = ({ code }) => {
    handleStreetCode(code)
	fetchZipCode();
}
const { disableCityField } = useDisableCityField();

watch(isExistingAccount, () => {
    showShipping.value = isExistingAccount.value;
});
</script>
<template>
	<div class="fields" v-if="!onlyEsim">
		<div class="checkbox">
			<input type="checkbox" id="field-other-address" :checked="showShippingAddress" @click="sendSimToAddress">
			<label for="field-other-address" class="fz15">
				{{ title }}
			</label>
		</div><!-- /.checkbox -->

		<template v-if="!showShippingAddress">
			<div class="fields__head">
				<h6>
					{{ label }}
				</h6>
			</div><!-- /.fields__head -->

			<div class="fields__body">
				<FieldCity
					:name="shippingSettlementName"
					:label="`${__('Settlement')} *`"
					@selected="handleSelectedCity"
					:type="name"
					:isShipping="true"
				/>

				<FieldStreet 
					:name="shippingStreettName"
					:label="`${__('Street')} *`"
					:city_code="cityCode"
					@selected="handleSelectedStreet"
					:type="name"
					:isShipping="true"
					:disabled="!cityCode"
				/>
				<ErrorMessage :name="`${name}ShippingStreetCode`" as="span" class="field__error" />

				<FieldsAddress :type="`${clientType}Shipping`" isShipping="true" />

			</div><!-- /.fields__body -->
		</template>
	</div><!-- /.fields -->
</template>